exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-___footer__wrapper___qovdf{width:100%;height:60px;padding:20px 40px;background:rgba(0,0,0,0.05);display:flex;justify-content:space-between;align-items:center;position:absolute;bottom:0;left:0}.src-components-___footer__wrapper___qovdf p{margin-bottom:0}.src-components-___footer__links___BzZX- a:not(:last-of-type){margin-right:20px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-___footer__wrapper___qovdf",
	"links": "src-components-___footer__links___BzZX-"
};